const SPECIAL_LANGUAGES = ['tr', 'ja', 'hi'];

export const isSpecialLanguage = (languageCode: string) => SPECIAL_LANGUAGES.includes(languageCode);
